import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import { GetSingleSurvey, reset } from "../../../features/SurveySlice";

import {
  Card,
  Button,
  Form,
  Col,
  Row,
  Table,
  ListGroup,
} from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";

import BASE_URL from "../../../api";

const FormAnswerPage = () => {
  const [newData, setNewData] = useState({
    nama: "",
    deskripsi: "",
    active: true,
    detail: [],
  });

  // collect data to post it into db/api
  const [dataPost, setDataPost] = useState([]);

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.survey);

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());

    // fetch data.
    if (id) {
      fetchData();
    }
  }, [id, dispatch, token]);

  function fetchData() {
    dispatch(reset());
    dispatch(GetSingleSurvey({ id, token }));
  }

  useEffect(() => {
    setNewData({
      nama: data?.data?.nama,
      deskripsi: data?.data?.deskripsi,
      detail: data?.data?.detail,
      active: data?.data?.active,
    });
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dataPost?.length === newData?.detail?.length) {
      showAlertDialog({
        title: "Simpan?",
        msg: `apakah anda yakin ingin menyimpan survey ini?`,
        confirmButtonText: "Simpan",
        onConfirm: async () => {
          showLoadingDialog();
          try {
            const response = await axios.post(
              `${BASE_URL}survey`,
              [...dataPost],
              {
                headers: {
                  Authorization: token,
                },
              }
            );
            console.log("RESPONSE : ", response);
            hideLoadingDialog();
            showSuccessDialog({
              title: "Berhasil!",
              msg: "Berhasil menyimpan data!",
            });
            // TODO :: IT SHOULD REDIRECT TO PREVIOUS ROUTE
            navigate("/dashboard");
          } catch (error) {
            console.log("ERROR", error);
            hideLoadingDialog();
            showFailedDialog({
              title: "Oops!",
              msg: error?.response?.data?.message || "Gagal menyimpan data!",
            });
          }
        },
      });
    } else {
      showFailedDialog({
        title: "Oops!",
        msg: "Mohon isi semua data!",
      });
    }
  };

  return (
    <AdminLayout>
      <Header />
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          newData={newData}
          dataPost={dataPost}
          setDataPost={setDataPost}
          isLoading={isLoading}
          isLocked={true}
          handleSubmit={handleSubmit}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  id,
  newData,
  dataPost,
  setDataPost,
  isLocked = false,
  isLoading = false,
  handleSubmit,
}) => {

  const onClickResponse = (event, idDetail, point) => {
    event.preventDefault(); // Prevent default form submission behavior
    // point is (10=>SANGAT PUAS|5=>PUAS|1=>BIASA|0=>TIDAK PUAS)
    if (dataPost?.some((obj) => obj.id_detail_survey === idDetail)) {
      // update existing data instead of creating new one
      const theIdx = dataPost?.findIndex(
        (obj) => obj.id_detail_survey === idDetail
      );
      const copyDataPost = [...dataPost];
      copyDataPost[theIdx] = Object.assign(
        { ...copyDataPost[theIdx] },
        {
          point: point,
        }
      );
      setDataPost([...copyDataPost]);
    } else {
      const updatedEditDetail = [
        ...(dataPost || []),
        {
          id_survey: id,
          id_detail_survey: idDetail,
          point: point,
        },
      ];
      setDataPost([...updatedEditDetail]);
    }
  };

  const isActive = (idDetail, point) => {
    if (dataPost?.some((obj) => obj.id_detail_survey === idDetail)) {
      const theIdx = dataPost?.findIndex(
        (obj) => obj.id_detail_survey === idDetail
      );
      return dataPost[theIdx].point === point;
    }
    return false;
  };

  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group id="Nama">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Nama"
                  name="nama"
                  disabled={isLocked}
                  value={newData.nama || ""}
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="Deskripsi">
                <Form.Label>Deskripsi</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Deskripsi"
                  name="deskripsi"
                  disabled={isLocked}
                  value={newData.deskripsi || ""}
                />
              </Form.Group>
            </Col>
            <hr data-content="Detail" className="hr-text" />
            <Col md={12} className="mb-3">
              <Table
                responsive
                striped
                className="table-centered table-nowrap rounded mb-0"
              >
                <thead className="thead-light">
                  <tr>
                    <th className="border-0">#</th>
                    <th className="border-0">Deskripsi</th>
                    <th className="border-0">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {(newData.detail || []).length > 0 ? (
                    newData.detail?.map((item, i) => (
                      <tr key={i}>
                        <th>{i + 1}</th>
                        <th>{item.deskripsi}</th>
                        <th style={{ textAlign: "center" }}>
                          {
                            <ListGroup horizontal>
                              <ListGroup.Item
                                variant="danger"
                                action
                                onClick={(e) => onClickResponse(e, item.id, 1)}
                                active={isActive(item.id, 1)}
                              >
                                TIDAK PUAS
                              </ListGroup.Item>
                              <ListGroup.Item
                                variant="warning"
                                action
                                onClick={(e) => onClickResponse(e, item.id, 2)}
                                active={isActive(item.id, 2)}
                              >
                                BIASA
                              </ListGroup.Item>
                              <ListGroup.Item
                                variant="info"
                                action
                                onClick={(e) => onClickResponse(e, item.id, 3)}
                                active={isActive(item.id, 3)}
                              >
                                PUAS
                              </ListGroup.Item>
                              <ListGroup.Item
                                variant="success"
                                action
                                onClick={(e) => onClickResponse(e, item.id, 4)}
                                active={isActive(item.id, 4)}
                              >
                                SANGAT PUAS
                              </ListGroup.Item>
                            </ListGroup>
                          }
                        </th>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <th colSpan="3" style={{ textAlign: "center" }}>
                        Tidak ada data!
                      </th>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
          <div>
            <Button type="submit">Simpan</Button>
          </div>
        </Form>
      )}
    </Card.Body>
  );
};

export default FormAnswerPage;
